import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "99220f3e-af09-42a7-8c87-63604085cb3c",
    label: "DG(BLDG)'s Office Order No. 10 of 2015-2016",
    date: "30/03/2016",
    subject: "Verification of land record",
  },
  {
    fileStoreId: "bde6d4f8-c6f1-45fe-9309-00d1ccbf1bd7",
    label: "DG(BLDG)'s Office Order No. 06 of 2015-2016",
    date: "15/02/2016",
    subject: "Cost of Compactor and BI Code",
  },
  {
    fileStoreId: "0ea313ea-dfe8-4fa7-96a7-b75a854ad72a",
    label: "DG(BLDG)'s Office Order No. 05 of 2015-2016",
    date: "12/12/2015",
    subject: "Forged NOC of ULC",
  },
  {
    fileStoreId: "ad23c47a-a57c-45c2-a235-d10a07e87ec9",
    label: "DG(BLDG)'s Office Order No. 02 of 2015-2016",
    date: "10/09/2015",
    subject: "Guide line to use Holograms and Papers",
  },
];

const Building_OfficeOreder_2015 = () => (
  <TableStructure
    title="Office Order/ 2015"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2015;
